import {Component} from "@angular/core";

@Component({
    selector: "fui-pops",
    templateUrl: "./pops.component.html"
})
export class FUIPopsComponent {
    constructor() {
    }
}
